module.exports = __webpack_public_path__ + "static/media/rails.509f3551.png";